const TYPE_KEYS = {
  SKILL: 'skill',
  CERT: 'certification',
};

export default TYPE_KEYS;
